import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Loader from '../Components/Loader';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Checking your account...');

  useEffect(() => {
    let timeouts = [];

    const handleCallback = async () => {
      try {
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError || !session?.user) {
          setMessage('❌ Authentication failed. Please try again.');
          const t1 = setTimeout(() => navigate('/login'), 2000);
          timeouts.push(t1);
          return;
        }

        const user = session.user;

        // Check personal table for status
        const { data: personal, error: personalError } = await supabase
          .from('personal')
          .select('status')
          .eq('user_id', user.id)
          .maybeSingle();

        if (personalError) {
          console.error('Personal check error:', personalError);
        }

        if (personal?.status === 'active') {
          // Existing complete user
          setMessage('✅ Welcome back! Redirecting...');
          const t2 = setTimeout(() => navigate('/home', { replace: true }), 1000);
          timeouts.push(t2);
        } else if (personal?.status === 'onboarding') {
          // Started but didn't finish
          setMessage('📝 Please complete your signup...');
          const t3 = setTimeout(() => navigate('/personal-info', { replace: true }), 1500);
          timeouts.push(t3);
        } else {
          // No personal record = truly new user
          // Create with onboarding status
          const { error: createError } = await supabase
            .from('personal')
            .insert({
              user_id: user.id,
              email: user.email,
              status: 'onboarding',
              name: '',
              age: 0,
              dob: '',
              country: '',
              phone: ''
            });

          if (createError) {
            console.error('Personal creation error:', createError);
            setMessage('❌ Error creating profile. Please try again.');
            const t4 = setTimeout(() => navigate('/login'), 2000);
            timeouts.push(t4);
            return;
          }

          setMessage('📝 New account! Please complete your profile...');
          const t5 = setTimeout(() => navigate('/personal-info', { replace: true }), 1500);
          timeouts.push(t5);
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setMessage('❌ Something went wrong. Please try again.');
        const t6 = setTimeout(() => navigate('/login'), 2000);
        timeouts.push(t6);
      }
    };

    handleCallback();

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#1a1b1e',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      padding: '20px',
      textAlign: 'center',
    }}>
      <Loader size={80} />
      <p style={{ marginTop: '30px', fontSize: '16px', color: '#b5bac1' }}>
        {message}
      </p>
    </div>
  );
}